<template>
  <nav
    class="header__mobile"
    :class="{ 'open-menu': isToggled, blog: isBlog, default: !isBlog }"
  >
    <div class="header__mobile__wrapper">
      <div class="header__inner">
        <header-mobile-toggle
          :on-toggle="onToggleButtonPressed"
        ></header-mobile-toggle>
        <a
          href="/"
          class="header__logo"
          @click="onMainLinkClicked('ShopKeep Logo')"
        >
          <img v-bind:src="logo" />
        </a>
        <div class="header__call" id="header__phone-number" v-show="!isToggled">
          <a :href="'tel:+' + phone" @click="onMainLinkClicked(phone)">{{
            phone
          }}</a>
        </div>
      </div>

      <div class="header__mobile__links" :style="headerLinksStyle">
        <ul class="header__links">
          <li class="header__mobile__links--left">
            <ul class="header__mobile__links--left-list">
              <li
                v-for="item in navItems.left.items"
                :key="item.label"
                :class="{
                  header__links__items: true,
                  'header__links__items--parent': item.children
                }"
              >
                <p v-if="!item.href" class="header__links--parent__label">
                  {{ item.label }}
                </p>
                <a
                  :href="item.href"
                  v-if="!item.children"
                  class="header__links--parent__label"
                  :data-nav-type-text="navItems.type"
                  @click="onLinkClicked(item.label)"
                  >{{ item.label }}</a
                >

                <ul
                  v-if="item.children"
                  v-bind:class="{
                    'header__links--child': true
                  }"
                >
                  <li
                    v-for="child in item.children"
                    :key="child.label"
                    class="header__links__items"
                  >
                    <a
                      v-if="child.href"
                      :href="child.href"
                      class="header__links--child__label"
                      :data-parent-label="item.label"
                      :data-nav-type-text="navItems.type"
                      @click="onChildLinkClicked(child.label, item.label)"
                      :target="child.open_link_in_new_tab ? '_blank' : null"
                      >{{ child.label }}</a
                    >
                    <span v-else class="header__links--labels">{{
                      child.label
                    }}</span>
                  </li>
                </ul>
              </li>
            </ul>
          </li>

          <li class="header__mobile__links--right">
            <ul class="header__mobile__links--right-list">
              <li
                v-for="item in navItems.right.items"
                :key="item.label"
                :class="{
                  header__links__items: true,
                  'header__links__items--parent': item.children
                }"
              >
                <p v-if="!item.href" class="header__links--parent__label">
                  {{ item.label }}
                </p>
                <a
                  :href="item.href"
                  v-if="!item.children"
                  class="header__links--parent__label"
                  :data-nav-type-text="navItems.type"
                  @click="onLinkClicked(item.label)"
                  >{{ item.label }}</a
                >

                <ul
                  v-if="item.children"
                  v-bind:class="{
                    'header__links--child': true
                  }"
                >
                  <li
                    v-for="child in item.children"
                    :key="child.label"
                    class="header__links__items"
                  >
                    <div v-if="child.children">
                      <div
                        class="header__links--subchild-heading-container"
                        @click="toggleSubchild(child)"
                      >
                        <p class="header__links--child__label">
                          {{ child.label }}
                        </p>
                        <svg class="header__links--subchild-arrow">
                          <use
                            :xlink:href="
                              `#arrow-${
                                isSubchildToggled(child) ? 'up' : 'down'
                              }`
                            "
                          />
                        </svg>
                      </div>
                      <ul
                        class="header__links--subchild-list"
                        :style="{
                          'max-height': isSubchildToggled(child)
                            ? `${22 * child.children.length}px`
                            : '0'
                        }"
                      >
                        <li
                          v-for="subchild in child.children"
                          :key="subchild.label"
                        >
                          <a
                            :href="subchild.href"
                            class="header__links--subchild__label"
                            :data-parent-label="child.label"
                            :data-nav-type-text="navItems.type"
                            :target="subchild.open_link_in_new_tab ? '_blank' : null"
                            >{{ subchild.label }}</a
                          >
                        </li>
                      </ul>
                    </div>
                    <template v-else>
                      <template v-if="child.subscribe_to_blog_link">
                        <p
                          class="header__links--child__label"
                          @click="blogSubscribeTriggered()"
                          v-if="isWordpress"
                        >
                          {{ child.label }}
                        </p>
                        <header-email-signup
                          :header="header"
                          :label="child.label"
                          v-if="!isWordpress"
                        ></header-email-signup>
                      </template>
                      <a
                        :href="child.href"
                        class="header__links--child__label"
                        :data-parent-label="item.label"
                        :data-nav-type-text="navItems.type"
                        @click="onChildLinkClicked(child.label, item.label)"
                        v-else
                        >{{ child.label }}</a
                      >
                    </template>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
        </ul>
        <div class="header__mobile--bottom">
          <div class="header__mobile--bottom__left" v-if="isWordpress">
            <div class="header-mobile__nav-button-container header-mobile__nav-button-container--default">
              <lightbox-button
                target="lightboxMarketoOptimizely"
                class="header__trial"
                >Get Started</lightbox-button
              >
            </div>
          </div>

          <div class="header__mobile--bottom__left" v-else>
            <div
              class="header-mobile__nav-button-container header-mobile__nav-button-container--default"
            >
              <optimizely-button
                class-name="header__trial"
                :target="mainForm.lightbox_target"
                :optimizely-prefix="mainForm.optimizely_prefix"
                :prefix="mainForm.ga_prefix"
                href="/signup"
                >Get Started</optimizely-button
              >
            </div>
            <div
              class="header-mobile__nav-button-container header-mobile__nav-button-container--test"
            >
              <optimizely-button
                class-name="header__trial"
                target="lightboxStarterJunctionNav"
                href="/signup"
                id="sk-free-trial"
                >Get Started</optimizely-button
              >
            </div>
            <div
              class="header-mobile__nav-button-container header-mobile__nav-button-container--starter-everywhere"
            >
              <nav-link-button
                class="header__trial"
                href="/pricing"
                cta="Get Started Free"
              ></nav-link-button>
            </div>
          </div>

          <div class="header__mobile--bottom__right">
            <button
              class="header__mobile--bottom__right--login__button"
              @click="loginClicked()"
            >
              {{ loginText }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import Vue from 'vue';
import $ from 'jquery';
import cookies from 'js-cookie';
import VueHelpers from '../../mixins/vue-helpers';
import HeaderMobileToggle from './HeaderMobileToggle.vue';
import HeaderEmailSignup from './HeaderEmailSignup.vue';
import OptimizelyButton from '../lightbox/OptimizelyButton.vue';
import LightboxButton from '../lightbox/LightboxButton.vue';
import NavLinkButton from '../button/NavLinkButton.vue';

const MAIN_NAV_GA_KEY = 'Main';

export default {
  props: {
    logo: {
      type: String,
      required: true
    },
    isBlog: {
      type: Boolean,
      required: true
    },
    isWordpress: {
      type: Boolean,
      required: true
    },
    header: {
      type: Object,
      required: true
    },
    phone: {
      type: String,
      required: true
    },
    mainForm: {
      type: Object,
      required: true
    },
  },
  mixins: [VueHelpers],
  components: {
    HeaderMobileToggle,
    HeaderEmailSignup,
    OptimizelyButton,
    LightboxButton,
    NavLinkButton
  },
  data() {
    return {
      isToggled: false,
      toggledSubchildren: {},
      loginText: 'Log In'
    };
  },
  watch: {
    isToggled(newValue) {
      //remove desktop subscribe form and paste into mobile nav
      //assuming this was done originally to avoid having 2 forms with the same marketo ids
      if (newValue) {
        const blogSubscribeLightbox = $(
          this.emailSignUpLightboxSelector
        ).detach();
        $(this.$el).append(blogSubscribeLightbox);
      }
      //put the lightbox back for desktop
      else {
        const blogSubscribeLightbox = $(
          this.emailSignUpLightboxSelector
        ).detach();
        $('.nav__email-signup').append(blogSubscribeLightbox);
      }
    }
  },
  computed: {
    emailSignUpLightboxSelector() {
      return this.isWordpress
        ? '.nav__email-signup__lightbox'
        : 'aside[for="lightboxMarketoEmailSignup"]';
    },
    headerLinksStyle() {
      const style = {
        overflow: 'visible',
        display: 'block'
      };
      if (!this.isToggled) {
        style.overflow = 'hidden';
        style.display = 'none';
      }
      return style;
    },
    navItems() {
      if (this.isBlog) {
        return this.header.main_mobile_blog;
      }
      return this.header.main_mobile;
    },
    navType() {
      return this.isBlog ? 'Blog' : MAIN_NAV_GA_KEY;
    }
  },
  methods: {
    onChildLinkClicked(childLabel, parentLabel) {
      let navText;

      if (this.isBlog && parentLabel === 'Blog') {
        navText = childLabel;
      } else {
        navText = `${parentLabel} > ${childLabel}`;
      }

      dataLayer.push({ event: 'navigation', navType: this.navType, navText });
    },
    onLinkClicked(navText) {
      dataLayer.push({ event: 'navigation', navType: this.navType, navText });
    },
    onMainLinkClicked(navText) {
      dataLayer.push({
        event: 'navigation',
        navType: MAIN_NAV_GA_KEY,
        navText
      });
    },
    onToggleButtonPressed(newValue) {
      this.isToggled = newValue;
      const navAction = newValue ? 'Mobile Menu Open' : 'Mobile Menu Close';
      //Marketing wants navType to always be Main, even when toggling on blog (for historical reasons.)
      dataLayer.push({
        event: 'navigation',
        navType: MAIN_NAV_GA_KEY,
        navText: navAction
      });
    },
    childIsToggled(string) {
      return (
        this.$root.headerChildToggled === string ||
        this.$root.headerChildPrevious === string
      );
    },
    loginClicked() {
      dataLayer.push({
        event: 'navigation',
        navType: this.navType,
        navText: this.loginText
      });
      const twentyYears = 7300; // JS Cookie - 1 is 1 day
      cookies.set('_sk_login', 'yes', { expires: twentyYears });
      window.shopkeepCookies.login = 'yes';
      window.location.href = 'https://www.shopkeepapp.com/login';
    },
    keyForItem(item) {
      return item.label;
    },
    toggleSubchild(item) {
      const key = this.keyForItem(item);
      // Vue.set(this.toggledSubchildren, key, !this.toggledSubchildren[key]);
      //only allow 1 menu to be toggled at a time. Commented out above line allows multiple menus to be toggled at a time
      const newToggledSubchildren = {};
      newToggledSubchildren[key] = !this.toggledSubchildren[key];
      this.toggledSubchildren = newToggledSubchildren;
    },
    isSubchildToggled(item) {
      return this.toggledSubchildren[this.keyForItem(item)];
    },
    blogSubscribeTriggered() {
      document.querySelector(this.emailSignUpLightboxSelector).style.display =
        'block';
    }
  }
};
</script>
